


















import { notEmptyString } from "@/api/validators";
import { bus } from "@/main";
import { WindowState } from "@/store/types";
import { Component, Prop, Vue } from "vue-property-decorator";
import { State } from "vuex-class";
import SnippetItem from "./SnippetItem.vue";

@Component({
  components: {
    SnippetItem,
  },
})
export default class HelpWidget extends Vue {
  @Prop({ default: "site" }) section: string;
  @Prop({ default: "" }) name: string;
  @Prop({ default: "" }) text: string;
  @State("window") window: WindowState;

  active = false;

  alignFromRight = false;

  alignFromBottom = false;

  created() {
    bus.$on("escape", this.close);
    bus.$on("open-overlay", this.close);
    bus.$on("open-help", (relKey) => {
      if (relKey !== this.comboKey) {
        this.close();
      }
    });
  }

  toggleHelp() {
    const bounds = this.$el.getBoundingClientRect();
    const { width, height } = this.window;
    this.alignFromRight = bounds.x > width * 0.625;
    this.alignFromBottom = bounds.y > height * 0.625;
    this.active = !this.active;
    if (this.active) {
      bus.$emit("open-help", this.comboKey);
    }
  }

  close() {
    this.active = false;
  }

  get wrapperClasses() {
    const statusClass = this.active ? "active" : "inactive";
    const xCl = this.alignFromRight ? "from-right" : "from-left";
    const yCl = this.alignFromBottom ? "from-bottom" : "from-top";
    return [statusClass, xCl, yCl];
  }

  get textKey() {
    const max = 32;
    const remWords = ['the', 'a', 'of', 'an','in', 'on', 'this', 'setting', 'you', 'if', 'have', 'has', 'is', 'are', 'and', 'or'];
    const source = this.text.toLowerCase().split(/[^a-z0-9]+/).filter(w => remWords.indexOf(w) < 0 && w.length > 1).join('_');
    const ln = source.length;
    const numChars = ln > max ? max: ln;
    const start = ln > max * 2? Math.ceil(max / 2) : 0;
    return source.substring(start, start + numChars);
  }

  get comboKey() {
    const secPart = notEmptyString(this.name, 2)? this.name : this.textKey;
    return [this.section, secPart].join("__");
  }

  get hasOwnText() {
    return this.name.length < 2 && notEmptyString(this.text, 4);
  }

  get hasSnippetRef() {
    return !this.hasOwnText && notEmptyString(this.name, 2);
  }
}
